import Vue from "vue";
import moment from "moment";

const resourceReservation = {
  namespaced: true,
  mutations: {
    SET_ITEMS( state, payload ){
  //    state.items[ payload.id ] = Object.assign({}, state.items[ payload.id ], payload.data );
    },
    UNSET_ITEMS( state, payload ){

    },
    SET_LIST( state, payload ){

    },
    CLEAR_LIST( state, payload ){

    },
  },
  getters: {
    GET_ITEMS_BY_LIST: state => payload => {
      /* payload로 날아온 listName을 이용해서 state.lists를 조회 후, state.lists[ listName ].docs 를 받아오면 댐. */
    }
  },
  actions: {
    // 서비스 예약용 API
    createServiceItems({ state, rootState, commit, dispatch }, payload ){
      // up_is_reservation_service(_접수자 INT, ,_상담자 INT, _회원 INT, _상담시간 DATETIME,_전화번호 VARCHAR(20),차량번호 VARCHAR(20),_경로 VARCHAR(20), _접수자메모  VARCHAR(1000))
      // 접수자, 상담자, 회원 모두 0으로 입력
      // 경로에는 서비스명을 입력
      // ref 
      var dcd_ref = ""
      try{ dcd_ref = decodeURI(window.document.referrer) }catch(e) {}
      var tmp = Object.keys(payload).find(e => e.indexOf("상담") >= 0)
      if(tmp != undefined){
        var _params = {
          adminj: payload.adminj ? payload.adminj : 35,
          admin: payload.admin ? payload.admin : 35,
          customer_id: '0',
          reservation_carnumber: payload[tmp].step_datas.carNumber.value, // 차량번호
          reservation_name: payload[tmp].step_datas.name.value,
          reservation_contract: payload[tmp].step_datas.phone.value,
          reservation_date_request: moment(payload[tmp].step_datas.consultDate.value).format('YYYY-MM-DD') + ' ' + payload[tmp].step_datas.consultTime.value,
          reservation_memo: payload[tmp].step_datas.consultRemark.value,      
          reservation_inflow: payload[tmp].step_datas.insureName.value, //경로
          referrer: dcd_ref
        }
        return new Promise( ( resolve, reject ) => {
          Vue.axios.post( rootState.config.hostName + "/v1/www/reservation.service/create", _params ).then( res => {
            //commit( "SET_ITEM", res.data )
            return resolve( res );
          }).catch( reject );
        });
      }
      
    },
    createItems({ state, rootState, commit, dispatch }, payload ){
      // up_is_reservation`(_접수자 INT,_상담자 INT, _회원 INT, _상담시간 DATETIME,_전화번호 VARCHAR(20),_보험종목 VARCHAR(20),_경로 VARCHAR(20), _접수자메모  VARCHAR(1000))
      var dcd_ref = ""
      try{ dcd_ref = decodeURI(window.document.referrer) }catch(e) {}
      var tmp = Object.keys(payload).find(e => e.indexOf("상담") >= 0)

      if(tmp != undefined){
        var type = payload[tmp].step_datas.insureName.value
        var _memo = "[전화상담예약] "+ (type.indexOf('보험')<0?type:type.substr(0, type.indexOf('보험'))) + " "+payload[tmp].step_datas.name.value+"님께서 상담예약하였습니다. 시간에 맞춰 연락하십시오. "
        _memo = _memo + "\n상담내용 : " + payload[tmp].step_datas.consultRemark.value

        if( payload[tmp].event === true) {
          _memo = _memo.replace('[전화상담예약] ', '[전화상담예약][이벤트] ')
        }

        if (payload.checkmyinsure) {
          _memo = `${_memo}\n[보험점검]`;
        }

        let reservation_inflow = payload.source ? payload.source : '홈페이지';

        if (payload.reservation_inflow) {
          reservation_inflow = payload.reservation_inflow;
        }
                
        const reservation_date_request = payload[tmp].step_datas.consultDate.value.replace(/\./g, '-');
        const reservation_contract =  payload[tmp].step_datas.phone.value.replace(/-/g, '');

        var _params = {
          tmp,
          adminj: payload.adminj ? payload.adminj : 35,
          admin: payload.admin ? payload.admin : 35,
          customer_id: payload.customer_id ? payload.customer_id : '0',
          reservation_type: payload[tmp].step_datas.insureName.value === '실손의료보험' ? '실손' : payload[tmp].step_datas.insureName.value,
          reservation_name: payload[tmp].step_datas.name.value,
          reservation_contract,
          reservation_date_request: moment(reservation_date_request).format('YYYY-MM-DD') + ' ' + payload[tmp].step_datas.consultTime.value,
          reservation_memo: _memo,      
          reservation_inflow,
          referrer: dcd_ref,
          ip: payload.ip,
          checkmyinsure: payload.checkmyinsure,
          reservation_inflow_referer_source: payload.reservation_inflow_referer_source
        }

        return new Promise( ( resolve, reject ) => {
          Vue.axios.post( rootState.config.hostName + "/v1/www/reservation/create", _params ).then( res => {
            //commit( "SET_ITEM", res.data )
            if(window.ReactNativeWebView) {
              window.ReactNativeWebView.postMessage(
                JSON.stringify({
                  evenType: 'createReservation',
                  resMsg: '성공',
                  resCode: 200,
                  data: _params
                })
              );
            }
            var tmp_in = _params.reservation_type;
            if(tmp_in == '실손의료보험') tmp_in = '실손보험'

            Vue.axios.post('https://asia-northeast1-qprice-db76b.cloudfunctions.net/smsc', {
              "key" : "Ek*)ns$(J!hQ3Z?o<Pv[d^AfTYY!i4a{w|D[PVOZy|5}tWb?CvTVJOJNSowIZw",
              "rp" : _params.reservation_contract,
              "sp" : "16681100",
              "mg" : `[인슈넷FC]${tmp_in} 상담예약이 접수되었습니다. 예약변경=> http://fcs.kr/Y9qgoX`,
              "sa" : "1009000"
            });

            return resolve( res );
          }).catch( reject );
        });
      }
      
    },
    /* 구) 전화상담 예약시 기존엔 이쪽으로 전달됨*/
    updateItems({ state, rootState, commit, dispatch }, payload ){
      var _params = {
        customer_id: payload.customer_id,
        reservation_type: payload.전화상담.step_datas.insureName.value,
        reservation_name: payload.전화상담.step_datas.name.value,
        reservation_contract: payload.전화상담.step_datas.phone.value,
        reservation_date_request: moment(payload.전화상담.step_datas.consultDate.value).format('YYYY-MM-DD') + ' ' + payload.전화상담.step_datas.consultTime.value,
        reservation_memo: payload.전화상담.step_datas.consultRemark.value,      
        reservation_inflow: '홈페이지',
      }
      /*var _params = {
        customer_id : payload.data.cid,
        reservation_type : payload.data.insureName,
        reservation_contract : payload.data.phone,
        reservation_memo : payload.data.consultRemark,
        reservation_date_request : moment( payload.data.consultDate ).format('YYYY-MM-DD') + ' ' + payload.data.consultTime,
        reservation_name : payload.data.name,
        reservation_inflow : '홈페이지',
      }*/
      //_params = {...payload};
      //return;
      return new Promise( ( resolve, reject ) => {
        Vue.axios.post( rootState.config.hostName + "/v1/crm/reservation/create", _params ).then( res => {
          //commit( "SET_ITEM", res.data )
          return resolve( res );
        }).catch( reject );
      });
    },
    createItemsForLifePremium({ state, rootState, commit, dispatch }, payload ){
      var _params = payload
      return new Promise( ( resolve, reject ) => {
        Vue.axios.post( rootState.config.hostName + "/v1/www/reservation/create", _params ).then( res => {
          var tmp_in = _params.reservation_type;
          Vue.axios.post('https://asia-northeast1-qprice-db76b.cloudfunctions.net/smsc', {
            "key" : "Ek*)ns$(J!hQ3Z?o<Pv[d^AfTYY!i4a{w|D[PVOZy|5}tWb?CvTVJOJNSowIZw",
            "rp" : _params.reservation_contract,
            "sp" : "16681100",
            "mg" : `[인슈넷FC]${tmp_in} 상담예약이 접수되었습니다. 예약변경=> http://fcs.kr/Y9qgoX`,
            "sa" : "1009000"
          });

          return resolve( res );
        }).catch( reject );
      });
    },
    createItemsForLifePremiumWeb({ rootState }, payload) {
      const { hostName } = rootState.config;

      return new Promise((resolve, reject) => {
        Vue.axios
          .post(`${hostName}/v1/www/reservation.web/create`, payload)
          .then(resolve)
          .catch(reject);
      });
    },
    getReservation({ state, rootState, commit, dispatch }, payload) {
      return new Promise( ( resolve, reject ) => {
        Vue.axios.get( rootState.config.hostName + `/v1/www/reservation/${payload._id}`).then( res => {
          return resolve( res );
        }).catch( reject );
      });
    },
    updateReservation({ state, rootState, commit, dispatch }, payload) {
      return new Promise( ( resolve, reject ) => {
        Vue.axios.put( rootState.config.hostName + `/v1/www/reservation/edit/${payload._id}`, payload ).then( res => {
          return resolve( res );
        }).catch( reject );
      });
    }
  }

};

export default resourceReservation;
